import React from "react"
import { tableStyle, thStyle, tdStyle, emptyBoxStyle, loadingStyle } from "../styles/commonStyles"

const DataTable = ({ headers, rows, loading = false, emptyMessage = "No data found", className = "", widths }) => {
	if (loading) {
		return <div style={loadingStyle}>Loading...</div>
	}

	if (!rows || rows.length === 0) {
		return (
			<div style={emptyBoxStyle}>
				<span>{emptyMessage}</span>
			</div>
		)
	}

	return (
		<div style={{ overflowX: "auto" }} className={className}>
			<table style={tableStyle}>
				<thead>
					<tr>
						{headers.map((header, index) => (
							<th key={index} style={thStyle} width={widths && widths[index] ? widths[index] : "auto"}>
								{header}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((row, index) => (
						<tr key={index}>
							{row.map((cell, cellIndex) => (
								<td key={cellIndex} style={tdStyle}>
									{cell}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

export default DataTable
